<template>
  <div class="seat-map-mobile-nav">
    <div class="seat-map-mobile-nav__segment">
      {{ currentSegment ? formatSegmentLabel(currentSegment) : "" }}
    </div>
    <div class="seat-map-mobile-nav__pax-list">
      <button
        v-for="pax in paxRows"
        :key="pax.id"
        type="button"
        :class="[
          'seat-map-mobile-nav__pax-row',
          'm-0',
          'btn',
          'btn-ghost',
          { 'is-current': pax.isCurrent, 'has-seat': pax.hasSeat },
        ]"
        @click="setCurrentPassengerId(pax.id)"
      >
        <span class="seat-map-mobile-nav__pax-name text-ellipsis">
          {{ pax.displayName
          }}<span v-if="pax.hasInfant"> con neonato</span>
        </span>
        <vb-icon
          v-if="pax.hasSeat"
          name="check_circle"
          :color="color_success"
          :size="14"
          class="ml-1 seat-map-mobile-nav__pax-icon"
        />
      </button>
    </div>
  </div>
</template>

<script>
import {
  formatPassengerName,
  formatSegmentLabel,
} from "@liveflight/utilities/mixins";
import { get_passenger_seat } from "@liveflight/utilities/seat-map";
import { color_success } from "@liveflight/resources/colors";

export default {
  name: "seat-map-mobile-nav",
  props: {
    currentSegment: Object,
    currentSegmentId: String,
    currentPassengerId: String,
    sittingPassengers: { type: Array, default: () => [] },
    parsedSelections: { type: Object, default: () => ({}) },
    setCurrentPassengerId: Function,
  },
  data() {
    return {
      color_success,
    };
  },
  computed: {
    paxRows() {
      return this.sittingPassengers.map((pax) => ({
        id: pax.id,
        displayName: formatPassengerName(pax),
        hasInfant: Boolean(pax.holding),
        isCurrent: pax.id === this.currentPassengerId,
        hasSeat: Boolean(
          get_passenger_seat(
            this.parsedSelections,
            this.currentSegmentId,
            pax.id,
          ),
        ),
      }));
    },
  },
  methods: {
    formatSegmentLabel,
  },
};
</script>

<style lang="scss">
.seat-map-mobile-nav {
  display: block;
  margin-bottom: $grid-gutter-width / 2;

  @include media-breakpoint-up(xl) {
    display: none;
  }

  &__segment {
    @include font-primary-bold;
    font-size: $font-size-base;
    margin-bottom: $grid-gutter-width / 2;
  }

  &__pax-list {
    border: 1px solid $gray-300;
    border-radius: $border-radius;
    background-color: $extra1;
  }

  &__pax-row {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 44px;
    padding: $grid-gutter-width / 4 $grid-gutter-width / 2;
    border-bottom: 1px solid $gray-300;
    border-radius: 0;
    text-align: left;

    &:last-child {
      border-bottom: 0;
    }

    &.is-current .seat-map-mobile-nav__pax-name {
      @include font-primary-semibold;
      text-decoration: underline;
    }

    &.has-seat .seat-map-mobile-nav__pax-name {
      color: $success;
    }
  }

  &__pax-name {
    flex: 1;
    color: $body-color;
  }

  &__pax-icon {
    flex-shrink: 0;
  }
}
</style>
